import { ArrowUpSvg, UploadSvg } from "@/assets/icons";
import styles from "./index.module.scss";
import { MouseEventHandler, useEffect, useRef, useState } from "react";
import clsx from "clsx";
// import FotorPictureSelect from "@ft/picture-select";
import { useUserStore } from "@/stores";
import { TYPE_LIMIT_ACCEPT } from "@/constants";
//
import loadable from "@loadable/component";
const FotorPictureSelect = loadable(() => import("@ft/picture-select"));
type UploadButtonProps = {
  title: string;
  disabled?: boolean;
  className?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  isShowTrigger?: boolean;
  onSelect?: (files: any[]) => void;
};

const UploadButton = (props: UploadButtonProps) => {
  const {
    title,
    className,
    disabled,
    onClick,
    isShowTrigger,
    onSelect,
  } = props;

  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const isLogin = useUserStore(state => state.getters.isLogin);
  const showLogin = useUserStore(state => state.showLogin);

  const handleOpenChange = (value: boolean) => {
    setOpen(value);
  }

  useEffect(() => {
    const listner = (e: MouseEvent) => {
      const target = e.target as Element;
      if (triggerRef.current && !triggerRef.current.contains(target)) {
        setOpen(false);
      }
    }

    document.addEventListener("click", listner);

    return () => {
      document.removeEventListener("click", listner);
    }
  }, []);

  return (
    <div
      className={clsx(
        styles["root"],
        className,
      )}
    >
      <button
        className={styles["left_button"]}
        disabled={disabled}
        onClick={onClick}
      >
        <UploadSvg></UploadSvg>
        <span
          className="single_row_ellipsis"
        >
          {title}
        </span>
      </button>

      {isShowTrigger && (
        <FotorPictureSelect
          isLogin={isLogin}
          domain={process.env.REACT_APP_BASE_URL}
          fotorCloudDomain={process.env.REACT_APP_FOTOR_CLOUD_URL}
          theme="light"
          isDropboxChooser={false}
          accept={TYPE_LIMIT_ACCEPT}
          limitCount={1}
          hiddenFromItems={["from_google_photo", "from_dropbox", "from_dropbox_chooser"]}
          onSelect={onSelect}
          onLogin={showLogin}
          placement="bottom-right"
          onOpenChange={handleOpenChange}
        >
          <button
            className={clsx(
              styles["trigger"],
              open && styles["open"]
            )}
          >
            <span className={styles["split"]}></span>
            <ArrowUpSvg></ArrowUpSvg>
          </button>
        </FotorPictureSelect>
      )}
    </div>
  )
}

export default UploadButton;